import React from 'react';
import LoginForm from './forms/LoginForm';

const Login = () => <LoginForm />;

export default Login;
